import { render } from "./FormControlsSaveClose.vue?vue&type=template&id=42fed2da"
import script from "./FormControlsSaveClose.vue?vue&type=script&lang=js"
export * from "./FormControlsSaveClose.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__